export const isString = value => value != null && typeof value === "string";
